module.exports = __webpack_public_path__ + "media/images/logo-9ba8ada5de0c69ace12905be4eb0fbb1.png";